import { action, atom } from "@reatom/framework";
import { CounterDto } from "definitions/counter-api";

export const addSubscribeModalOpen = atom(false, "addSubscribeModalOpen");
export const addSubscribeModalData = atom<CounterDto | null>(
  null,
  "addSubscribeModalData",
);

export const openAddSubscribeModalAction = action(
  (ctx, props: CounterDto | null = null) => {
    addSubscribeModalData(ctx, props);
    addSubscribeModalOpen(ctx, true);
  },
);
